import React, {useEffect, useState} from 'react';
import SelectBox from './v2/form/select-box';
import Link from 'next/link';

const PuzzleGameForm = ({ onSuccess }) => {

    let isValidInputs = true;
        const [firstName, setFirstName] = useState("");
        const [firstNameErr, setFirstNameErr] = useState(false);
        const [email, setEmail] = useState("");
        const [emailErr, setEmailErr] = useState(false);
        const [socialMediaLink, setSocialMediaLink] = useState("");
        const [socialMediaLinkErr, setSocialMediaLinkErr] = useState(false);
        const [companyName, setCompanyName] = useState("");
        const [companyNameErr, setCompanyNameErr] = useState(false);
        const [slackCommunity, setSlackCommunity] = useState('');
        const [slackCommunityErr, setSlackCommunityErr] = useState(false);
        const [querySent, setQuerySent] = useState(false);
        const [querySentText, setQuerySentText] = useState("Thanks for reaching out! We will look over your message and get back to you soon");

        const validateInputs = () => {
            const emailRegEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let emailId = email
            let isInvalidEmail = emailId.length < 2 || !emailRegEx.test(String(emailId).toLowerCase())
            let isInvalidFirstName = firstName.length < 3
            let isInvalidSocialMediaLink = socialMediaLink.length < 3
            let isInvalidCompanyName = companyName.length < 1

            if(isInvalidEmail){
                setEmailErr(true)
            }
            if(isInvalidFirstName){
                setFirstNameErr(true)
            }
            if(isInvalidSocialMediaLink){
                setSocialMediaLinkErr(true)
            }
            if(isInvalidCompanyName){
                setCompanyNameErr(true)
            }

            isValidInputs = !isInvalidEmail && !isInvalidFirstName && !isInvalidSocialMediaLink  && !isInvalidCompanyName
        }
        const handleSubmit = (e) => {
            e.preventDefault()
            validateInputs()
            if(isValidInputs){
                var xhr = new XMLHttpRequest();
                var url = "https://api.hsforms.com/submissions/v3/integration/submit/25310090/b428405b-e067-430e-b13e-883d40cf0157";
                var data = {
                    submittedAt: Date.now(),
                    fields: [
                        {
                            name: "firstname",
                            value: firstName,
                        },
                        {
                            name: "email",
                            value: email,
                        },
                        {
                            name: "jobtitle",
                            value: socialMediaLink,
                        },
                        {
                            name: "company",
                            value: companyName,
                        },
                        {
                            name: "source_type",
                            value: 'Puzzle Game',
                        },

                    ],
                };
                var final_data = JSON.stringify(data);
                xhr.open("POST", url);
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.onreadystatechange = function () {
                    if (xhr.readyState == 4 && xhr.status == 200) {
                        setEmail('')
                        setFirstName('')
                        setSocialMediaLink('')
                        setCompanyName('')
                        // setSlackCommunity(false)
                        setQuerySent(true)
                        setQuerySentText("Thanks for reaching out! We will look over your message and get back to you soon")
                        
                        // Call the success callback to trigger dialog close
                        if (onSuccess) {
                            onSuccess();
                        }
                        
                        setTimeout(()=>{
                            setQuerySent(false)
                        },6000)
                        // Returns a 200 response if the submission is successful.
                    } else if (xhr.readyState == 4 && xhr.status == 400) {
                        setQuerySentText(xhr.responseText)
                    } else if (xhr.readyState == 4 && xhr.status == 403) {
                        setQuerySentText(xhr.responseText)
                    }
                };
                xhr.send(final_data);
            }
        }


    return (
        <>
            <div className={'form partner-form-pop puzzle-game-form'}>
                <h2>🎉 <span className='text-gradient'>Congratulations</span> for Successfully Completing the Puzzle! 🎉</h2>
                <p>Please fill your details to win <b>Kubernetes Certification!</b> <br/> The result will be announced on <b>15th Oct, 2025</b>.</p>
                <form onSubmit={(e) => handleSubmit(e)}>
                    <div className={'d-flex'}>
                        <div className={'input-wrapper'}>
                            <label>Name*</label>
                            <input type={'text'} placeholder={'Your Name'}
                                   className={`${firstNameErr ? 'is-error' : ''}`}
                                   value={firstName}
                                   onChange={(e) => {
                                       const value = e.target && e.target.value
                                       setFirstName(value)
                                   }}
                                   onKeyUp={(e) => {
                                       if (firstName.length > 0) {
                                           setFirstNameErr(false)
                                       }
                                   }}
                            />
                            <h6 className={`form-input-validation ${firstNameErr ? 'error' : ''}`}>Minimum 3 characters
                                required</h6>
                        </div>
                        <div className={'input-wrapper'}>
                            <label>Email*</label>
                            <input type={'email'} placeholder={'youremail@gmail.com'}
                                   className={`${emailErr ? 'is-error' : ''}`}
                                   value={email}
                                   onChange={(e) => {
                                       const value = e.target && e.target.value
                                       setEmail(value)
                                   }}
                                   onKeyUp={(e) => {
                                       if (email.length > 0) {
                                           setEmailErr(false)
                                       }
                                   }}
                            />
                            <h6 className={`form-input-validation ${emailErr ? 'error' : ''}`}>{email.length < 1 ? 'Email is required' : 'Please enter business email'}</h6>
                        </div>
                    </div>
                    <div className={'d-flex'}>
                    <div className={'input-wrapper'}>
                            <label>Company name*</label>
                            <input type={'text'} placeholder={'Your Company Name'}
                                   className={`${companyNameErr ? 'is-error' : ''}`}
                                   value={companyName}
                                   onChange={(e) => {
                                       const value = e.target && e.target.value
                                       setCompanyName(value)
                                   }}
                                   onKeyUp={(e) => {
                                       if (companyName.length > 0) {
                                           setCompanyNameErr(false)
                                       }
                                   }}
                            />
                            <h6 className={`form-input-validation ${companyNameErr ? 'error' : ''}`}>Company name is
                                required</h6>
                        </div>

                        <div className={'input-wrapper'}>
                            <label>Social Media Link*</label>
                            <input type={'text'} placeholder={'https://www.linkedin.com/in/yourname'}
                                   className={`${socialMediaLinkErr ? 'is-error' : ''}`}
                                   value={socialMediaLink}
                                   onChange={(e) => {
                                       const value = e.target && e.target.value
                                       setSocialMediaLink(value)
                                   }}
                                   onKeyUp={(e) => {
                                       if (socialMediaLink.length > 0) {
                                           setSocialMediaLinkErr(false)
                                       }
                                   }}
                            />
                            <h6 className={`form-input-validation ${socialMediaLinkErr ? 'error' : ''}`}>Minimum 3 characters
                                required</h6>
                        </div>
                    </div>
                    <div className={'input-wrapper checkbox-puzzle'}>
                    <input type={'checkbox'} placeholder={'https://www.linkedin.com/in/yourname'}
                                   className={`${socialMediaLinkErr ? 'is-error' : ''}`}
                                   value={slackCommunity}
                                   onChange={(e) => {
                                       const value = e.target && e.target.value
                                       setSlackCommunity(value)
                                   }}
                            />
                            <label>Have you joined the Slack Community? <Link href="https://middlewarepublic.slack.com/join/shared_invite/zt-39l76rpo6-ZNGfpA_4U_kYL6oTuYAgmQ" target="_blank" >https://middlewarepublic.slack.com/join/shared_invite/zt-39l76rpo6-ZNGfpA_4U_kYL6oTuYAgmQ</Link></label>
                            
                            <h6 className={`form-input-validation ${socialMediaLinkErr ? 'error' : ''}`}>Minimum 3 characters
                                required</h6>
                        </div>
                    
                    
                    
                    <button type={'submit'} className={'primary'}>Submit</button>
                    {querySent &&
                        <h6 className={`form-input-validation ${querySent ? 'success' : 'error'}`}>{querySentText}</h6>}
                </form>
            </div>
        </>
    )
}

export default PuzzleGameForm;